import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Upload, Sparkles, Download, FileSpreadsheet, Columns3, History, FileDown, AlertTriangle, Copy, Wand2, Gauge, Settings2, Table2, BadgeCheck, ScrollText } from "lucide-react";

const TABS = [
  ["import", "Import Data", Upload], ["ai-import", "AI Import", Sparkles], ["export", "Export Data", Download], ["templates", "Import Templates", FileSpreadsheet],
  ["mappings", "Field Mapping", Columns3], ["history", "Import History", History], ["exports", "Export History", FileDown], ["errors", "Error Reports", AlertTriangle],
  ["duplicates", "Duplicate Review", Copy], ["enrichment", "AI Enrichment", Wand2], ["quality", "Data Quality", Gauge], ["records", "Records & Bulk Edit", Table2],
  ["claims", "Business Claims", BadgeCheck], ["audit", "Audit Log", ScrollText], ["settings", "Import Settings", Settings2],
];

export default function DataCenterLayout() {
  return (
    <div data-testid="data-center">
      <div className="mb-6">
        <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#165a71]">Data Center</div>
        <div className="mt-3 flex flex-wrap gap-1.5 pb-2" data-testid="dc-tabs">
          {TABS.map(([to, label, Icon]) => (
            <NavLink key={to} to={`/admin/data-center/${to}`} className={({ isActive }) => `shrink-0 inline-flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-[13px] font-medium border transition-colors ${isActive ? "bg-[#071b22] text-white border-[#071b22]" : "bg-white text-[#252A34]/80 border-slate-200 hover:border-[#165a71]/40"}`} data-testid={`dc-tab-${to}`}>
              <Icon className="h-3.5 w-3.5" />{label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
}
